import img1 from '../images/avatar/avt-1.jpg'
import img2 from '../images/avatar/avt-2.jpg'
import img3 from '../images/avatar/avt-3.jpg'
import img4 from '../images/avatar/avt-4.jpg'
import img5 from '../images/avatar/avt-5.jpg'
import img6 from '../images/avatar/avt-6.jpg'
import img7 from '../images/avatar/avt-7.jpg'
import img8 from '../images/avatar/avt-8.jpg'
import img9 from '../images/avatar/avt-9.jpg'




const topSellerData = [
    {
        // img: img1,
        img: 'https://axiesreact.surielementor.com/static/media/avt-1.71a23be871d509a23d2d.jpg',
        name: "Crispin Berry" ,
        price: "214.2 ETH",
        classPadding: ""
    },
    {
        // img: img2,
        img: 'https://axiesreact.surielementor.com/static/media/avt-2.e101dc63363945410d54.jpg',
        name: "Samson Frost" ,
        price: "205.43 ETH",
        classPadding: "pl-17"
    },
    {
        // img: img4,
        img: 'https://axiesreact.surielementor.com/static/media/avt-4.cbb2f9fb25c1e375d958.jpg',
        name: "Tommy Alrez" ,
        price: "170.3 ETH",
        classPadding: "pl-34"
    },
    {
        // img: img5,
        img: 'https://axiesreact.surielementor.com/static/media/avt-5.cb38feefc0ea48ef8f43.jpg',
        name: "Windsor Lane" ,
        price: "120.7 ETH",
        classPadding: "pl-51"
    },
    {
        // img: img3,
        img: 'https://axiesreact.surielementor.com/static/media/avt-3.c03860ca1e2872296499.jpg',
        name: "Andy Hurlbutt" ,
        price: "82.79 ETH",
        classPadding: "pl-68"
    },
    {
        // img: img8,
        img: 'https://axiesreact.surielementor.com/static/media/avt-8.5196d4a4839fce8a5b96.jpg',
        name: "Blake Banks" ,
        price: "68.2 ETH",
        classPadding: ""
    },
    {
        // img: img6,
        img: 'https://axiesreact.surielementor.com/static/media/avt-6.0f735e283e35e7c8f00c.jpg',
        name: "Monica Lucas" ,
        price: "52.8 ETH",
        classPadding: "pl-17"
    },
    {
        // img: img9,
        img: 'https://axiesreact.surielementor.com/static/media/avt-9.87baf90907513c1c10e6.jpg',
        name: "Matt Ramos" ,
        price: "38.4 ETH",
        classPadding: "pl-34"
    },
    {
        // img: img7,
        img: 'https://axiesreact.surielementor.com/static/media/avt-7.98fafb24331353eb43c0.jpg',
        name: "Harper Wilcher" ,
        price: "29.2 ETH",
        classPadding: "pl-51"
    },
    {
        // img: img1,
        img: 'https://axiesreact.surielementor.com/static/media/avt-4.cbb2f9fb25c1e375d958.jpg',
        name: "Crispin Berry" ,
        price: "214.2 ETH",
        classPadding: "pl-68"
    },
    {
        // img: img1,
        img: 'https://axiesreact.surielementor.com/static/media/avt-1.71a23be871d509a23d2d.jpg',
        name: "Crispin Berry" ,
        price: "214.2 ETH",
        classPadding: ""
    },
    {
        // img: img2,
        img: 'https://axiesreact.surielementor.com/static/media/avt-7.98fafb24331353eb43c0.jpg',
        name: "Samson Frost" ,
        price: "205.43 ETH",
        classPadding: "pl-17"
    },


]

export default topSellerData;